import { IAppLogoConfig } from "../../../types";
import { countryLogosConfig } from "./teamLogos";

export interface ITournamentConfig {
  stages: {
    groupStageId: string;
    roundOf32StageId?: string;
    roundOf16StageId?: string;
    quarterStageId?: string;
    semiStageId: string;
    thirdPlaceStageId?: string;
    finalStageId: string;
  };
  overlapMatchIds: string[];
  supportedMatchIds: string[];
  supportedMatchShowResultUntil?: ISupportedMatchShowResultUntil;
  teamLogos: IAppLogoConfig[];
  isClubTournament?: boolean;
  isGroupOnlyLeague?: boolean;
  tournamentName?: string;
  translatedTournamentName?: string;
}

export interface ISupportedMatchShowResultUntil {
  utcDate: number;
  utcHour: number;
  utcMinute: number;
}

export const appTournamentConfig: Record<string, ITournamentConfig> = {
  // FIFA World Cup 2026
  "873cbl9cd9butm4air0mugxzo": {
    stages: {
      groupStageId: "87i5eesbymvgzmz5d0y4a855g",
      roundOf32StageId: "brq0tx2gzolma2dl5evds8zkk",
      roundOf16StageId: "87eg1v78rvn1m7ze0fbd55fdg",
      quarterStageId: "87utpwh2p5cgus55sllhw1ogk",
      semiStageId: "87wvasku1999ckpqmf9t4fytw",
      thirdPlaceStageId: "87cjw00khw6uwuaenvgo27klw",
      finalStageId: "87ga24j0fz3zl7nuznnt5ma6s",
    },
    overlapMatchIds: [],
    supportedMatchIds: [
      // Group Stage
      "4tcpns1nwyc0jtpucgzj9dp90", // Mexico vs South Africa (2026-06-11)
      "9hjlhmip7tn4qgpwr47txpafo", // Korea Republic vs Czechia (2026-06-12)
      "y1ow9ht5baxn64i01hq9moes", // Canada vs Bosnia-Herzegovina (2026-06-12)
      "49wa9ymnt0trv2mjruak556ok", // United States vs Paraguay (2026-06-13)
      "2lzhf44ic9g2dj0l29fji2xw4", // Qatar vs Switzerland (2026-06-13)
      "ar8b186wqraa80u0vpi2e4nis", // Brazil vs Morocco (2026-06-13)
      "cydmo9vjfyvaefav6t1531xck", // Haiti vs Scotland (2026-06-14)
      "5d1c5lu90p9hhk82c0kcp05qs", // Australia vs Türkiye (2026-06-14)
      "cjc09ujyfc1ks4blsyl8hbfv8", // Germany vs Curaçao (2026-06-14)
      "424kyd0drjm51x8dsauowgpp0", // Netherlands vs Japan (2026-06-14)
      "ddupm8zbfndp54r8uru3obf9w", // Côte d'Ivoire vs Ecuador (2026-06-14)
      "4v4v3ge0g7tm1w9uzpoehmzh0", // Sweden vs Tunisia (2026-06-15)
      "66cem7lh6o8ckkfxp4tao7o5w", // Spain vs Cabo Verde (2026-06-15)
      "aw4mhrfav7b5r7d4lc6dwz1g4", // Belgium vs Egypt (2026-06-15)
      "6zuh8kndp7mz2j33tqajmos2c", // Saudi Arabia vs Uruguay (2026-06-15)
      "c4kuk30dj016i6gjwxw4clnh0", // IR Iran vs New Zealand (2026-06-16)
      "cqsflhc7vaul90l2d4ipzzzmc", // France vs Senegal (2026-06-16)
      "dk9nrrzts19sez2hpbxx7soic", // Iraq vs Norway (2026-06-16)
      "55108ze2r7d8dgkmcauepuhp0", // Argentina vs Algeria (2026-06-17)
      "67uqo1wgdcka1yxqltbiqxn9w", // Austria vs Jordan (2026-06-17)
      "aa59tfi9hkmjec05olroia13o", // Portugal vs Congo DR (2026-06-17)
      "jx85i5ao3wvsb8opsu0ic1sk", // England vs Croatia (2026-06-17)
      "1ewge3gy7siiimkd64tawg1zo", // Ghana vs Panama (2026-06-17)
      "b6gp5y32kvgossb0feqipr8r8", // Uzbekistan vs Colombia (2026-06-18)
      "cbn3r0bwd3283f8bj4vuvifis", // Czechia vs South Africa (2026-06-18)
      "4mov5r6nivdn6dhlmb9hv5q1g", // Switzerland vs Bosnia-Herzegovina (2026-06-18)
      "3luqmzpzk0qoh2tc96utv0ges", // Canada vs Qatar (2026-06-18)
      "bdoe50pj6ug3jrc5to1j8st1w", // Mexico vs Korea Republic (2026-06-19)
      "6dt4a73k05gldmswzc3tgxmvo", // United States vs Australia (2026-06-19)
      "exuljwp9gd116hkf5sox4q5g4", // Scotland vs Morocco (2026-06-19)
      "e6dmlhi5t34w58liv12sp591w", // Brazil vs Haiti (2026-06-20)
      "7evssbq9air6phyr658hcanmc", // Türkiye vs Paraguay (2026-06-20)
      "5nh4gmpiskmsjcy904osi5n2s", // Netherlands vs Sweden (2026-06-20)
      "ecp6v27q48jj6um9odhcahjbo", // Germany vs Côte d'Ivoire (2026-06-20)
      "9erlmm2s3kapioujs9clvcic", // Ecuador vs Curaçao (2026-06-21)
      "6c7t9tr9b24qfjwphblk6776c", // Tunisia vs Japan (2026-06-21)
      "8muyl6d5ahy04fbwarplcg3kk", // Spain vs Saudi Arabia (2026-06-21)
      "cz84ih3b6irraa24kj6kvtz4k", // Belgium vs IR Iran (2026-06-21)
      "9ic1j3k1bvdhabxn5crvsx6ac", // Uruguay vs Cabo Verde (2026-06-21)
      "ds4dbpzuq9s8a87zc84b58w7o", // New Zealand vs Egypt (2026-06-22)
      "6zhd6pt8kyzrbkgwq2i2k8u1g", // Argentina vs Austria (2026-06-22)
      "emsvcmkqvohy5qmhedopxtus4", // France vs Iraq (2026-06-22)
      "elv88zog1n9ratzzksyfumtw", // Norway vs Senegal (2026-06-23)
      "7mw80b82sfqh1le7swr7l8zdg", // Jordan vs Algeria (2026-06-23)
      "bwetcq2x65uyp68uztwcuw9hw", // Portugal vs Uzbekistan (2026-06-23)
      "28702hpanr32no1vpxmxhbok4", // England vs Ghana (2026-06-23)
      "2ypodyawtamo2zzadwm42g9hw", // Panama vs Croatia (2026-06-23)
      "csme1qixbyobvbac3o0td9uz8", // Colombia vs Congo DR (2026-06-24)
      "5irko4jg9o9ixmfz8cu3oxjpw", // Switzerland vs Canada (2026-06-24)
      "6eub9tlno07el5y4ajvumqqdw", // Bosnia-Herzegovina vs Qatar (2026-06-24)
      "1r744e2q8r9lfwjz888dzxmac", // Morocco vs Haiti (2026-06-24)
      "spvh4xw4rpclalcf1jhsrv2s", // Scotland vs Brazil (2026-06-24)
      "d7gajq1bxb1xtvqbuxivlk4r8", // Czechia vs Mexico (2026-06-25)
      "ec5p7nsiix511225m4yfqt250", // South Africa vs Korea Republic (2026-06-25)
      "1ela50pkr7ho1l8kbj6a1di50", // Ecuador vs Germany (2026-06-25)
      "2kh760gcb6c4liigtebtxtus4", // Curaçao vs Côte d'Ivoire (2026-06-25)
      "77okx4j2kol5e0806b6xf74lw", // Tunisia vs Netherlands (2026-06-25)
      "83o3gqwqwt5c9jskxmcpqjvv8", // Japan vs Sweden (2026-06-25)
      "8chdphpgdqjkj85rml9odn1uc", // Türkiye vs United States (2026-06-26)
      "9784oivu7jkgn66e0pnnsyr6c", // Paraguay vs Australia (2026-06-26)
      "1fxxfshtg3b7p2ya8789tke8k", // Norway vs France (2026-06-26)
      "2bi32jvwjtru3nrkulzx3ip04", // Senegal vs Iraq (2026-06-26)
      "ahb6v608gitlu543aevomjuac", // Uruguay vs Spain (2026-06-27)
      "bl0y9cpgj82lun5bhvz8r3u38", // Cabo Verde vs Saudi Arabia (2026-06-27)
      "ctfvqyihaptbye55z2v5jims", // Egypt vs IR Iran (2026-06-27)
      "enyd3pel1z18f8cikzixnwpw4", // New Zealand vs Belgium (2026-06-27)
      "3t13xxgisfsmlvm62iydvpqms", // Panama vs England (2026-06-27)
      "4n1jg6og0392ta1ncdefsn2tw", // Croatia vs Ghana (2026-06-27)
      "dsi0ga8gcy8xcrywdfj3i51qs", // Colombia vs Portugal (2026-06-27)
      "emz36epmepynr3ggfksojdmhg", // Congo DR vs Uzbekistan (2026-06-27)
      "8g2qr1sd0kqxtjcvybdfgzvh0", // Jordan vs Argentina (2026-06-28)
      "94kik3fjes44gzerha1wu2l90", // Algeria vs Austria (2026-06-28)

      // Round of 32 (16th Finals)
      "5m9cv89dxqg33qbdgfynvc6c4", // TBD (2026-06-28)
      "3hsg9oklerq6uua8pos3dmdck", // TBD (2026-06-29)
      "tcobopf76p8yaw9kit3fs8pg", // TBD (2026-06-29)
      "7hnbukswespa64jtdc81jgetw", // TBD (2026-06-30)
      "56nac7cdfhydresgbalcg33tg", // TBD (2026-06-30)
      "37odjdevbj57umggq3rh1az9w", // TBD (2026-06-30)
      "6x9sfww0qsk9jtn9fm6n2qk2c", // TBD (2026-07-01)
      "9x9n058kxdo1mmyyd0bngy49g", // TBD (2026-07-01)
      "1tges3bmhq44q1m8ojj9fhr10", // TBD (2026-07-01)
      "ef8yvmn1ivhbrnjyj133kf7ys", // TBD (2026-07-02)
      "c26uegvn7o8d3uyb04tuuxjbo", // TBD (2026-07-02)
      "a9a29jmg821rce6jl07v6rod0", // TBD (2026-07-02)
      "1pah6dqrmiqvtouxgbzlzoefo", // TBD (2026-07-03)
      "etsoc4p3zsifly6xks7ossl5g", // TBD (2026-07-03)
      "c328g6toeflzg65gf28592olw", // TBD (2026-07-03)
      "3e05jx7evbp03r1yvu3ryg0t0", // TBD (2026-07-04)

      // Round of 16 (8th Finals)
      "1tfdd32vy6ouod43ek7l7kc9g", // TBD (2026-07-04)
      "71syco9icpb3gpojexfq9sh04", // TBD (2026-07-04)
      "9fqb3vpytcmgk9pozahr7iz9w", // TBD (2026-07-05)
      "b083yrj18tbck1z0og2evbhuc", // TBD (2026-07-06)
      "5fim3od605k9wne6uuiw641ec", // TBD (2026-07-06)
      "7djxwsgj6k02ts4b8lj2akqok", // TBD (2026-07-07)
      "ceq6z0bte8pgdbc2uwxni0x78", // TBD (2026-07-07)
      "em70mwgw22fdt9i4womogw93o", // TBD (2026-07-07)

      // Quarter-finals
      "1ot14rn6x26nlaxaxt27wkrv8", // TBD (2026-07-09)
      "3a1xofm1wnspw1952k7e4du6s", // TBD (2026-07-10)
      "4mcheqqscjz2gduxagmcgeyhg", // TBD (2026-07-11)
      "68n1p6yn5507yxvrrgfzod3bo", // TBD (2026-07-12)

      // Semi-finals
      "61zv9h8fu4v0812uihvl7m3h0", // TBD (2026-07-14)
      "9jubv7maziug1x60neaq76g44", // TBD (2026-07-15)

      // 3rd Place Final
      "1wrjcpwj8cv0mb6d4yp67dams", // TBD (2026-07-18)

      // Final
      "57dotnff3xaafnxfltzt4czdg", // TBD (2026-07-19)
    ],
    teamLogos: countryLogosConfig,
    isClubTournament: false,
    tournamentName: "FIFA World Cup 2026",
    translatedTournamentName: "FIFA World Cup 2026",
  },

  // FIFA World Cup 2022 Qatar (Testing with played data)
  "2a8elwzsufmguwymxbshcx756": {
    stages: {
      groupStageId: "2awryriz2besyqksnv5o9db3e",
      roundOf16StageId: "2aslmox01di43ptlh7ts6egru",
      quarterStageId: "2b8f36o8i0ywf1e8qbi93cpd6",
      semiStageId: "2bad2ps033b2b6i3udtwgtf8q",
      thirdPlaceStageId: "2aphx9dh4leqhe48z8mj01fu2",
      finalStageId: "2aul720q5c849pdeufq5p36ui",
    },
    overlapMatchIds: [],
    supportedMatchIds: [
      // Group Stage
      "ak5kkxvpxf1url15gci42ly7e", // Qatar vs Ecuador (2022-11-20)
      "bzyh8uc9dcu6mnj4zpx9nh6hg", // England vs IR Iran (2022-11-21)
      "3f0123w3yjdwtargl0woxj5zo", // Senegal vs Netherlands (2022-11-21)
      "cqjyb3x9pe0qo4c42e95hxgd0", // United States vs Wales (2022-11-21)
      "4m0s4gizblpr3l276ix5dgmc4", // Argentina vs Saudi Arabia (2022-11-22)
      "avbiaqxicsaizf2optet7nevo", // Denmark vs Tunisia (2022-11-22)
      "5dw6bpqspol1hsnzlajwq7cpg", // Mexico vs Poland (2022-11-22)
      "ac04r9oqg77zxhk8nb69frbis", // France vs Australia (2022-11-22)
      "6g8e1xiu2rs0w282p83pfwhzo", // Morocco vs Croatia (2022-11-23)
      "wx2oq2d4n48ry5xbj5e5rj10", // Germany vs Japan (2022-11-23)
      "5v0hr6bkd7m3zqf1spp6zpjo", // Spain vs Costa Rica (2022-11-23)
      "5h4ag1lnp0wfomz6mtluy52j8", // Belgium vs Canada (2022-11-23)
      "d8pj4078rabiygykxm7dk445w", // Switzerland vs Cameroon (2022-11-24)
      "3lchplzf3ejiui38txxktoges", // Uruguay vs Korea Republic (2022-11-24)
      "2zz4co26d48d5mwngnh2sfjtg", // Portugal vs Ghana (2022-11-24)
      "cbsd5fm3ivkh6u0tfh4mkucd0", // Brazil vs Serbia (2022-11-24)
      "1072ddxqvn5yty7iq5r09fp5g", // Wales vs IR Iran (2022-11-25)
      "6qbmepe6g6gn9bpyxfr5ids7o", // Qatar vs Senegal (2022-11-25)
      "82qmmzhrqe5gw3bosc5a3xy50", // Netherlands vs Ecuador (2022-11-25)
      "dfpxwqzmpkuhaqmkw14d9vaxg", // England vs United States (2022-11-25)
      "ccwk2q7xidkimtxsgyivf5ez8", // Tunisia vs Australia (2022-11-26)
      "75rd1phznaww3r6fvqj6u7jtg", // Poland vs Saudi Arabia (2022-11-26)
      "boonnukoavpo3nwio7lv6jrx0", // France vs Denmark (2022-11-26)
      "6ji2d9gscr9rah31vliip5tlg", // Argentina vs Mexico (2022-11-26)
      "28rgj1u8qp0gefw4jg14n56ac", // Japan vs Costa Rica (2022-11-27)
      "7fgtsy0p8qdoexvf3bof98s9g", // Belgium vs Morocco (2022-11-27)
      "88h01ghn4thqe0rbr21sa702c", // Croatia vs Canada (2022-11-27)
      "1jdbfhmoxyv1shmz5vqsyjrx0", // Spain vs Germany (2022-11-27)
      "ek8qzqnynkcdltx07vk91ekus", // Cameroon vs Serbia (2022-11-28)
      "5ipj0nkzk07krbne8b9f9wkr8", // Korea Republic vs Ghana (2022-11-28)
      "dyknehdqoyrb50xd7orsjcx78", // Brazil vs Switzerland (2022-11-28)
      "4agtnd9r89kfnpk27y7abn6z8", // Portugal vs Uruguay (2022-11-28)
      "92m5u8bccair120ftajyvayvo", // Netherlands vs Qatar (2022-11-29)
      "9u7rvy04f3k3142jvw0wr8u8k", // Ecuador vs Senegal (2022-11-29)
      "1rk98okqqlqxpk8bog302d3pw", // Wales vs England (2022-11-29)
      "2m2oexgxa7jsm96xazvx2gf10", // IR Iran vs United States (2022-11-29)
      "d0cuxth50n6ei4vr5msou1st0", // Tunisia vs France (2022-11-30)
      "do8iptn2hyb8i1g1fq1psubkk", // Australia vs Denmark (2022-11-30)
      "7wu5w4mfdu4q7p1gtw2rtxvdg", // Poland vs Argentina (2022-11-30)
      "8jpdbq72twug6v7a3f3fi9p90", // Saudi Arabia vs Mexico (2022-11-30)
      "a3eystf6qgau4ae1dszmto8ic", // Croatia vs Belgium (2022-12-01)
      "arodjol3unw5v1mepv0mnlq1g", // Canada vs Morocco (2022-12-01)
      "36zgyts8t2qzgz1cd56gm740k", // Japan vs Spain (2022-12-01)
      "3wbczxf9wmb7k14wv22y8ocno", // Costa Rica vs Germany (2022-12-01)
      "652o3vvt04ttpwarfxgq9sduc", // Korea Republic vs Portugal (2022-12-02)
      "6vt7yejfbrvo2d80lsem3rz84", // Ghana vs Uruguay (2022-12-02)
      "f21bfvqoobo8znffsl14c1wd0", // Cameroon vs Brazil (2022-12-02)
      "zbe055a1sbhicxf7x2ifenmc", // Serbia vs Switzerland (2022-12-02)
      // Round of 16 (8th Finals)
      "3yeo9n9dkr75f70bo9lcosewa", // Netherlands vs United States (2022-12-03)
      "egl2ic1x3t9fxkdewikqeejxm", // Argentina vs Australia (2022-12-03)
      "21c4pmd61gkqhqo8uxwrk7nfu", // France vs Poland (2022-12-04)
      "3yowhdtoklrukfkubuqxm3gx6", // England vs Senegal (2022-12-04)
      "9t63lrnr7aia41uo9xyk75ld6", // Japan vs Croatia (2022-12-05)
      "6uhi1xmvr7m1m2mrr8dn5dvmy", // Brazil vs Korea Republic (2022-12-05)
      "cd2xmgzpsulenoc6zqs38fywa", // Morocco vs Spain (2022-12-06)
      "ej2hy8f687mqy0j4uat4yy5ii", // Portugal vs Switzerland (2022-12-06)
      // Quarter-finals
      "6pjywulo227g9olkreqoforxm", // Croatia vs Brazil (2022-12-09)
      "8eu2695b9d7eztjmikxp446lm", // Netherlands vs Argentina (2022-12-09)
      "axih1cydh1x1xseezxdiqhqi2", // Morocco vs Portugal (2022-12-10)
      "cwkf4pd6fq0xu42o0kpm7yfl6", // England vs France (2022-12-10)
      // Semi-finals
      "pypvtrhbgg8d21q3hbm3osq2", // Argentina vs Croatia (2022-12-13)
      "2pd48fsy3sthzejemeyv13gbu", // France vs Morocco (2022-12-14)
      // 3rd Place Final
      "7e427ekkso82gl1zswxj3rbl6", // Croatia vs Morocco (2022-12-17)
      // Final
      "dn9kqyqgul5f1r43q6g544pka", // Argentina vs France (2022-12-18)
    ],
    teamLogos: countryLogosConfig,
    isClubTournament: false,
    tournamentName: "FIFA World Cup 2022",
    translatedTournamentName: "FIFA World Cup 2022",
  },

  // UEFA Champions League 2025/26
  "2mr0u0l78k2gdsm79q56tb2fo": {
    stages: {
      groupStageId: "2ouencfa64tmlqsqkeifsp6ok", // League Stage
      roundOf32StageId: "2omrc4p8836ybab2nijbhfxuc", // Knockout Round Play-offs
      roundOf16StageId: "2o7qneirq1k3duel43ams0z6c", // 8th Finals
      quarterStageId: "2pjtc9d9p3vea86xb2zywzdas", // Quarter-finals
      semiStageId: "2prgg5slp1de420l7eq6kwmj8", // Semi-finals
      finalStageId: "2of9suefyosz6atd2zydcfhg4", // Final
    },
    overlapMatchIds: [],
    supportedMatchIds: [
      // League Stage (144)
      "4ra5d8plwlqwcj0703hgi4rh0", // Athletic Club vs Arsenal (2025-09-16)
      "4rq18t2s467wo5dbh8iwip1jo", // PSV vs Union Saint-Gilloise (2025-09-16)
      "4s2m5vmbv79astpbzzz1bh8us", // Juventus vs Borussia Dortmund (2025-09-16)
      "4sffoari6ugnp3roi1m3k7xn8", // Real Madrid vs Olympique Marseille (2025-09-16)
      "4ss3nn1l6wqkwpfcnky8m6l1w", // Benfica vs Qarabağ (2025-09-16)
      "4t4v7a4pnyn93vudidzzjb6s4", // Tottenham Hotspur vs Villarreal (2025-09-16)
      "4thsy1pya5y11wggav6gql4wk", // Olympiakos Piraeus vs Pafos (2025-09-17)
      "4tvunt9ccx4cn40c8x2jlnwno", // Slavia Praha vs Bodø / Glimt (2025-09-17)
      "4u8iqbh8m9es525qyf4tsrifo", // Ajax vs Internazionale (2025-09-17)
      "4ul6yr2fksq114k3r287afg9g", // Bayern München vs Chelsea (2025-09-17)
      "4uxttaq5aye615oo9bylytl3o", // Liverpool vs Atlético de Madrid (2025-09-17)
      "4vah0y57kbchzjav53h65uv4k", // Paris Saint-Germain vs Atalanta (2025-09-17)
      "4vn56t4pxoy4bv8dlacifua6s", // Club Brugge vs Monaco (2025-09-18)
      "4vztu080wke11le259fjnfdp0", // København vs Bayer Leverkusen (2025-09-18)
      "4wcjch9j9nzd1cfu19oioy9sk", // Eintracht Frankfurt vs Galatasaray (2025-09-18)
      "4wp9z2tfe21drwyz966ojvpjo", // Manchester City vs Napoli (2025-09-18)
      "4x2w9j51dk7kc90orh6vkm2hg", // Newcastle United vs Barcelona (2025-09-18)
      "4xfj4wo4uaaxrxs3yo11cn7kk", // Sporting CP vs Kairat (2025-09-18)
      "4xs86vowvf2xcks0ln8eu9e6s", // Atalanta vs Club Brugge (2025-09-30)
      "4y59n6hs1chc516v7tjoivswk", // Kairat vs Real Madrid (2025-09-30)
      "4yjkn4fr15vuunkq4k1ishno4", // Atlético de Madrid vs Eintracht Frankfurt (2025-09-30)
      "4ywa27fk4gjqw9lpav3e2sy6s", // Chelsea vs Benfica (2025-09-30)
      "4z8to3catex92f0ng2u3f7310", // Internazionale vs Slavia Praha (2025-09-30)
      "4zlje47s72rm7ucdu1xma8jdg", // Bodø / Glimt vs Tottenham Hotspur (2025-09-30)
      "4zy839pwz57fo6s7vmh7ntv6c", // Galatasaray vs Liverpool (2025-09-30)
      "50aybm4aduzr2y0na0l1tj2tw", // Olympique Marseille vs Ajax (2025-09-30)
      "50nj6r3qfjg2ji8ayitzkiwpg", // Pafos vs Bayern München (2025-09-30)
      "5104qayfydr051q69yxvq9tzo", // Qarabağ vs København (2025-10-01)
      "51cxywc10d5578261crewjnkk", // Union Saint-Gilloise vs Newcastle United (2025-10-01)
      "51pmokefm21mo1i26kyokvvo4", // Arsenal vs Olympiakos Piraeus (2025-10-01)
      "5227vfuuiwhekbemsnyzbx3bo", // Monaco vs Manchester City (2025-10-01)
      "52evszwuzn8z1gg65tqgbgh78", // Bayer Leverkusen vs PSV (2025-10-01)
      "52ria8k29x4thupus7h3zcoic", // Borussia Dortmund vs Athletic Club (2025-10-01)
      "535v16ejka2ckhekin6euxg5w", // Barcelona vs Paris Saint-Germain (2025-10-01)
      "53ieurhaftrltylp7pe70795g", // Napoli vs Sporting CP (2025-10-01)
      "53uv9nt6mmwd2snmpdhdrzbx0", // Villarreal vs Juventus (2025-10-01)
      "547fv6pkd98zbsl3ha92ih0d0", // Barcelona vs Olympiakos Piraeus (2025-10-21)
      "54jwyyjv479n2g29919th9edw", // Kairat vs Pafos (2025-10-21)
      "54wrukg4isygsvnewwllku3o4", // Arsenal vs Atlético de Madrid (2025-10-21)
      "559m5skeluuo83bn5qad6rggk", // Bayer Leverkusen vs Paris Saint-Germain (2025-10-21)
      "55osvvn2rt4yh5rcx8dwf8gt0", // København vs Borussia Dortmund (2025-10-21)
      "562r0ddozxsa83y9l1wfm74t0", // Newcastle United vs Benfica (2025-10-21)
      "56flul4umnrjdekx5ny22y7tg", // PSV vs Napoli (2025-10-21)
      "56sbokbrbftomg93nof38dvro", // Union Saint-Gilloise vs Internazionale (2025-10-21)
      "574tgvqb4oyjvuwcmqqar4kyc", // Villarreal vs Manchester City (2025-10-21)
      "57hkc7sflvvd9br8rn38ahg5w", // Athletic Club vs Qarabağ (2025-10-22)
      "57vuceh50t8ljktlsz99kwh04", // Galatasaray vs Bodø / Glimt (2025-10-22)
      "588thaqsgswjlauvj2gp1orh0", // Monaco vs Tottenham Hotspur (2025-10-22)
      "58ls4qn0s2o0x3uzwo5lzs36c", // Atalanta vs Slavia Praha (2025-10-22)
      "58ypxe2wvxq7e89u8q0k0ep04", // Chelsea vs Ajax (2025-10-22)
      "59bpikh36bw9pwdd7xuyp30gk", // Eintracht Frankfurt vs Liverpool (2025-10-22)
      "59okcwx8e7548yvwcxc3b1b84", // Bayern München vs Club Brugge (2025-10-22)
      "5a1g6r8o0nw2fuy68ka0ls0es", // Real Madrid vs Juventus (2025-10-22)
      "5aef6fbewvou5chh024lqfrbo", // Sporting CP vs Olympique Marseille (2025-10-22)
      "5ar7r75v5tj8t5k5c0lafex3o", // Slavia Praha vs Arsenal (2025-11-04)
      "5b46wuyejszmlnabyu6px8lxw", // Napoli vs Eintracht Frankfurt (2025-11-04)
      "5bh296zaaweqezgf1h126snx0", // Atlético de Madrid vs Union Saint-Gilloise (2025-11-04)
      "5btub7q42mag1r6mj1qj74o44", // Bodø / Glimt vs Monaco (2025-11-04)
      "5c6o9gkconkcdrpnsx0b5k4r8", // Juventus vs Sporting CP (2025-11-04)
      "5cldkwitxdgvsmr4erkx8zyms", // Liverpool vs Real Madrid (2025-11-04)
      "5cybtcdp5uzclqdyjmojazk0k", // Olympiakos Piraeus vs PSV (2025-11-04)
      "5db7k467yfd4salognxrxgqac", // Paris Saint-Germain vs Bayern München (2025-11-04)
      "5dvbfx9w8zmqjabpmshvexs0k", // Tottenham Hotspur vs København (2025-11-04)
      "5e8c81yfj5wleflr99m651mok", // Pafos vs Villarreal (2025-11-05)
      "5eldqjhp1rtk3xd9olxavsvmc", // Qarabağ vs Chelsea (2025-11-05)
      "5eyjs5dmee4khfup2nzycajo4", // Ajax vs Galatasaray (2025-11-05)
      "5fbfmxmdror7xvtcq3a41pkpg", // Club Brugge vs Barcelona (2025-11-05)
      "5fofplo2ckg0386q0t12xen84", // Internazionale vs Kairat (2025-11-05)
      "5g2fgbz3xee5qeuzcpj6giv4k", // Manchester City vs Borussia Dortmund (2025-11-05)
      "5gj09fi5vmedayoh6kb4q08pg", // Newcastle United vs Athletic Club (2025-11-05)
      "5gvvzdmzgkymkhsskiiyiwdg4", // Olympique Marseille vs Atalanta (2025-11-05)
      "5h8w7ietnomxr4a3b88ewwk5w", // Benfica vs Bayer Leverkusen (2025-11-05)
      "5hnjhjd2o2wd899g579xeg6c4", // Ajax vs Benfica (2025-11-25)
      "5i0c80gxlounme20ekaqrx0yc", // Galatasaray vs Union Saint-Gilloise (2025-11-25)
      "5ift1ypsxbwlm3fh0yqke8h04", // Borussia Dortmund vs Villarreal (2025-11-25)
      "5iss7tc562nnymg0uiewtt0r8", // Chelsea vs Barcelona (2025-11-25)
      "5j5rc4wpittutm2qulb97arro", // Bodø / Glimt vs Juventus (2025-11-25)
      "5jj2hoxdj3jozbpos1o0t9j4k", // Manchester City vs Bayer Leverkusen (2025-11-25)
      "5jvxlvcsjl7gv4i0tj10rqntg", // Olympique Marseille vs Newcastle United (2025-11-25)
      "5k8vzrigcdi1o95w2pyfrxfys", // Slavia Praha vs Athletic Club (2025-11-25)
      "5klsgyaimzk0vf9kez1x7lno4", // Napoli vs Qarabağ (2025-11-25)
      "5kyx3oei9qwufppsacuaxnifo", // København vs Kairat (2025-11-26)
      "5lbsbtse68liz0gwxdru0oqvo", // Pafos vs Monaco (2025-11-26)
      "5loq6e5cekfnkddrm6my8xtzo", // Arsenal vs Bayern München (2025-11-26)
      "5m1qe4769ci21sl369uvd6has", // Atlético de Madrid vs Internazionale (2025-11-26)
      "5mkoywuiapszrete4cw6mtmok", // Eintracht Frankfurt vs Atalanta (2025-11-26)
      "5n3jb853xf57iw2n1sw8ioc9g", // Liverpool vs PSV (2025-11-26)
      "5nge0lsbrt22h9uycxvj2wiz8", // Olympiakos Piraeus vs Real Madrid (2025-11-26)
      "5ntaf1zmqcikn6d7tcxfhd7v8", // Paris Saint-Germain vs Tottenham Hotspur (2025-11-26)
      "5o69xht1oo35xkvbwqq94u0ic", // Sporting CP vs Club Brugge (2025-11-26)
      "5oj283apl8jj8cc5xrjaa4etw", // Kairat vs Olympiakos Piraeus (2025-12-09)
      "5ox5ahj58lip0umnt500qwjro", // Bayern München vs Sporting CP (2025-12-09)
      "5pa2vykzigbhxqstuu3wjgcgk", // Monaco vs Galatasaray (2025-12-09)
      "5pn7mzdx02v7lyxj8p1kr2cd0", // Atalanta vs Chelsea (2025-12-09)
      "5q05t4o4el0d6rhmncz6pxqms", // Barcelona vs Eintracht Frankfurt (2025-12-09)
      "5qd2von9gayml36rbaib0bdp0", // Internazionale vs Liverpool (2025-12-09)
      "5qqu3i9dgj6ummpnfzm05yf4k", // PSV vs Atlético de Madrid (2025-12-09)
      "5r3sfsleiu2c82yuruwzhcv84", // Union Saint-Gilloise vs Olympique Marseille (2025-12-09)
      "5rifo72z7v3jxnx77051fy978", // Tottenham Hotspur vs Slavia Praha (2025-12-09)
      "5rwblgpp1p54pam18ie7bjnro", // Qarabağ vs Ajax (2025-12-10)
      "5s9nt12is41lwav2mpse1fp5g", // Villarreal vs København (2025-12-10)
      "5smhf84om1dhdf2edquq6xo2c", // Athletic Club vs Paris Saint-Germain (2025-12-10)
      "5sze0q8qcefh8egwpzaiybx1w", // Bayer Leverkusen vs Newcastle United (2025-12-10)
      "5tcbsszjd0zwish7c0udvnzf8", // Borussia Dortmund vs Bodø / Glimt (2025-12-10)
      "5tp7r7lkjm2n3sj60puy8f7ys", // Club Brugge vs Arsenal (2025-12-10)
      "5u1wyaby2c1x5iom7r2070p3o", // Juventus vs Pafos (2025-12-10)
      "5ughwgykdnyfllb65u6fsou1g", // Real Madrid vs Manchester City (2025-12-10)
      "5uvmcr3z17bmsz8isqq8823h0", // Benfica vs Napoli (2025-12-10)
      "5v8hwooa0jtfx005o0xujkff8", // Kairat vs Club Brugge (2026-01-20)
      "5vlb0p47xj2o16q44uhptnthw", // Bodø / Glimt vs Manchester City (2026-01-20)
      "5vy63q5grjqxjipcqb8jljv9w", // København vs Napoli (2026-01-20)
      "5wmfkj6y4bbcpfbso62fcqoes", // Internazionale vs Arsenal (2026-01-20)
      "5x1rg4auxr06aqgnfvhfwzfo4", // Olympiakos Piraeus vs Bayer Leverkusen (2026-01-20)
      "5xf3kaeavedi0z5fyjm6llwr8", // Real Madrid vs Monaco (2026-01-20)
      "5xsc6ye9xqqmz62sa4qb8tlhw", // Sporting CP vs Paris Saint-Germain (2026-01-20)
      "5y5k8zvc34l3egxsjfjfy5edw", // Tottenham Hotspur vs Borussia Dortmund (2026-01-20)
      "5yisbecyd57sdyr6oobdot0yc", // Villarreal vs Ajax (2026-01-20)
      "5yw1ty2mjr8ne1oevh88nivbo", // Galatasaray vs Atlético de Madrid (2026-01-21)
      "5z9jt02azordg6y6m97cvmc5w", // Qarabağ vs Eintracht Frankfurt (2026-01-21)
      "5zmmmc2jjkytmiu66jih5nor8", // Atalanta vs Athletic Club (2026-01-21)
      "5zzgoq20bhr6m700r68oc87x0", // Chelsea vs Pafos (2026-01-21)
      "60cf47tmbsv54dj3ruq6r5dec", // Bayern München vs Union Saint-Gilloise (2026-01-21)
      "60pmm5c1dunl19bu2ivztc6qc", // Juventus vs Benfica (2026-01-21)
      "612tw4i5lz6slw42ufs22av4k", // Newcastle United vs PSV (2026-01-21)
      "61hsz6689o7g9ybeya58oox78", // Olympique Marseille vs Liverpool (2026-01-21)
      "61upafdbc4mwkdmp1k5ajqu50", // Slavia Praha vs Barcelona (2026-01-21)
      "629403zrbb8v8cq1g81v2lwk4", // Ajax vs Olympiakos Piraeus (2026-01-28)
      "62lvos0mfgim6h9rr88uu09hw", // Arsenal vs Kairat (2026-01-28)
      "62yriqtd43xg8ioh1ejxzw7pw", // Monaco vs Juventus (2026-01-28)
      "63bt6c9wn9nexq4z6mx3hopw4", // Athletic Club vs Sporting CP (2026-01-28)
      "63owkq641bskw0zmhc7rtjdw4", // Atlético de Madrid vs Bodø / Glimt (2026-01-28)
      "643ciwzf04i1nit402flk4n4k", // Bayer Leverkusen vs Villarreal (2026-01-28)
      "64g5mr0x49o08xbllu18gl3pw", // Borussia Dortmund vs Internazionale (2026-01-28)
      "64sx5q7qlo1ahz8cb3ss3lp90", // Club Brugge vs Olympique Marseille (2026-01-28)
      "656ifudbe32pxl0k263qrsq38", // Eintracht Frankfurt vs Tottenham Hotspur (2026-01-28)
      "65lxswiag0r6pt7m7s7nz6g44", // Barcelona vs København (2026-01-28)
      "65yo7coecrnl1gwgkdatt2xas", // Liverpool vs Qarabağ (2026-01-28)
      "66dpqixoih0mta26qwlp8sob8", // Manchester City vs Galatasaray (2026-01-28)
      "66qr8r2yuseer81y1i1tp5hqs", // Pafos vs Slavia Praha (2026-01-28)
      "674bu4uhq50y41dpeizevncic", // Paris Saint-Germain vs Newcastle United (2026-01-28)
      "67h5xtrudih8xgebmw0ni8178", // PSV vs Bayern München (2026-01-28)
      "67u5as824q96mp65srnyt7thw", // Union Saint-Gilloise vs Atalanta (2026-01-28)
      "68772t2j3wfmtm710ulwxrok4", // Benfica vs Real Madrid (2026-01-28)
      "68k4ds142ioex11nuohdtmoes", // Napoli vs Chelsea (2026-01-28)

      // Knockout Round Play-offs (16)
      "2ivwkprq3bnkkp2bfa2cdintg", // Galatasaray vs Juventus (2026-02-17)
      "4oh4lilh7picof2wixpo7jx90", // Monaco vs Paris Saint-Germain (2026-02-17)
      "6mfc71dto86yoss3ru9hegvmc", // Benfica vs Real Madrid (2026-02-17)
      "oex4se9z2myo4tc7eyhy9no4", // Borussia Dortmund vs Atalanta (2026-02-17)
      "5kfusd0dm3a7nj9phmwand7h0", // Qarabağ vs Newcastle United (2026-02-18)
      "15ep78m49s5us8i1cs0jo249g", // Olympiakos Piraeus vs Bayer Leverkusen (2026-02-18)
      "2x42c5yqdnkqekje6tf906rro", // Club Brugge vs Atlético de Madrid (2026-02-18)
      "7q33s9t4g6xvu2fzqz8fb9tsk", // Bodø / Glimt vs Internazionale (2026-02-18)
      "2xh1af1ne593geye7pqbdt1jo", // Atlético de Madrid vs Club Brugge (2026-02-24)
      "15s8p79c2831yqmuoafj9n6l0", // Bayer Leverkusen vs Olympiakos Piraeus (2026-02-24)
      "5ku5l0q1alklhnot6zgxnww7o", // Newcastle United vs Qarabağ (2026-02-24)
      "7qfyzlbmm47bxpk9p327ao1zo", // Internazionale vs Bodø / Glimt (2026-02-24)
      "oskmoxh73kh8jf9z4p8h0jys", // Atalanta vs Borussia Dortmund (2026-02-25)
      "2je80aixlyto9e2rtr0c0bpjo", // Juventus vs Galatasaray (2026-02-25)
      "4ouqf38r5q9tpki0erifsvuvo", // Paris Saint-Germain vs Monaco (2026-02-25)
      "6msydlb539kqt5cemmh8napec", // Real Madrid vs Benfica (2026-02-25)

      // Round of 16 / 8th Finals (16)
      "4mgtzo7ycptzkfyv1top89st0", // Galatasaray vs Liverpool (2026-03-10)
      "25hk7u04fup5ze2892je0za50", // Atlético de Madrid vs Tottenham Hotspur (2026-03-10)
      "a6nn40ztjvneh9okowz13fj84", // Atalanta vs Bayern München (2026-03-10)
      "cy57racub2br10hm6bcv5y39w", // Newcastle United vs Barcelona (2026-03-10)
      "7kfjarhihp4cwnarwndmwgufo", // Bayer Leverkusen vs Arsenal (2026-03-11)
      "2bhi66etavhwksr15mtds3jmc", // Paris Saint-Germain vs Chelsea (2026-03-11)
      "5o041y75gcsox89gw9ezbmwpg", // Bodø / Glimt vs Sporting CP (2026-03-11)
      "6nqqxwuv26u9t8rexoc10r85w", // Real Madrid vs Manchester City (2026-03-11)
      "5qh5y8vri1miit3i0qn7fp638", // Sporting CP vs Bodø / Glimt (2026-03-17)
      "2nekushi1t6nmi7ecukkoza50", // Chelsea vs Paris Saint-Germain (2026-03-17)
      "6qwoqwykx59aavhu3wobdqrdg", // Manchester City vs Real Madrid (2026-03-17)
      "86ciqz1lhb8781xd70dgc795g", // Arsenal vs Bayer Leverkusen (2026-03-17)
      "d3utvvilysz7lkewu7ylnqntg", // Barcelona vs Newcastle United (2026-03-18)
      "2a1ktq8ai1l1rh7uycbh0pk44", // Tottenham Hotspur vs Atlético de Madrid (2026-03-18)
      "4p8fjg0wpd5eyaa0t0mv8pzx0", // Liverpool vs Galatasaray (2026-03-18)
      "acixu0p06nshbxj1gmvu52rro", // Bayern München vs Atalanta (2026-03-18)

      // Quarter-finals (8)
      "9vufgb7gp2kyxzv8ftvwcesyc", // Real Madrid vs Bayern München (2026-04-07)
      "ck6gmfx70rbzasmqnq3ph7k0k", // Sporting CP vs Arsenal (2026-04-07)
      "7om4mss983m7d0dadr87xfuok", // Paris Saint-Germain vs Liverpool (2026-04-08)
      "b95mome0lnr0ff5mb4vqmej2s", // Barcelona vs Atlético de Madrid (2026-04-08)
      "3hvtgkttdl56azxog1v4ic844", // Atlético de Madrid vs Barcelona (2026-04-14)
      "ek0bykzmr876s0vcbxdqua3h0", // Liverpool vs Paris Saint-Germain (2026-04-14)
      "27wrp262d2qdqseiunjrk8dg4", // Bayern München vs Real Madrid (2026-04-15)
      "4qu1s75euu2ss5r6topy3alg4", // Arsenal vs Sporting CP (2026-04-15)

      // Semi-finals (4)
      "b5v1bdk3yghbdtgjwyqyjz02c", // Paris Saint-Germain vs Bayern München (2026-04-28)
      "ca2i4o1c3ajp4nhwbvs6tmqs4", // Atlético de Madrid vs Arsenal (2026-04-29)
      "em2v2c6m9jnpx7kkz1fomfz84", // Arsenal vs Atlético de Madrid (2026-05-05)
      "dkvlgk22rlyecfay5qgz48wes", // Bayern München vs Paris Saint-Germain (2026-05-06)

      // Final (1)
      "6sb5ga83yrll15624x1z0gwt0", // Paris Saint-Germain vs Arsenal (2026-05-30)
    ],
    teamLogos: countryLogosConfig,
    isClubTournament: true,
    tournamentName: "UEFA Champions League",
    translatedTournamentName: "UEFA Champions League",
  },
};

// matchId-derived tournament wins over an explicit ?tournamentId= so a wrong
// URL value can't override the correct one a known matchId implies.
export const TOURNAMENT_ID = (() => {
  const matchId = getMatchIdFromParams();
  if (matchId) {
    const derived = findTournamentIdForMatch(matchId);
    if (derived) return derived;
  }
  return getTournamentIdParam() ?? import.meta.env.VITE_TOURNAMENT_ID;
})();

export const MATCH_ID = getMatchIdFromParams();

export const getColorFromConfig = (teamName: string, isAway?: boolean) => {
  const tournamentConfig = appTournamentConfig[TOURNAMENT_ID];
  const teamColor = tournamentConfig?.teamLogos?.find((tm) =>
    teamName.includes(tm.name),
  );

  const result = {
    textColor: isAway ? teamColor?.textColor.away : teamColor?.textColor.home,
    shirtColor: isAway
      ? teamColor?.statsColor?.away
      : teamColor?.statsColor?.home,
  };

  return result;
};

function getTournamentIdParam() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("tournamentId");
}

export function getMatchIdFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("matchId");
}

export const isNationsLeague = false;

export function findTournamentIdForMatch(matchId: string): string | null {
  for (const [tournamentId, config] of Object.entries(appTournamentConfig)) {
    if (config.supportedMatchIds?.includes(matchId)) return tournamentId;
  }
  return null;
}
